//epi
import barreArrimage from "assets/puzzles/iserba/pacman/epi/barre_d_arrimage.svg";
import bloqueDisjoncteur from "assets/puzzles/iserba/pacman/epi/bloque_disjoncteur.svg";
import cadenas from "assets/puzzles/iserba/pacman/epi/cadenas_de_consignation.svg";
import casque from "assets/puzzles/iserba/pacman/epi/casque_anti_bruit.svg";
import casquette from "assets/puzzles/iserba/pacman/epi/casquette_coquée.svg";
import chaussures from "assets/puzzles/iserba/pacman/epi/chaussures_de_sécurité.svg";
import gantsCoupures from "assets/puzzles/iserba/pacman/epi/gants_anti_coupures.svg";
import gantsChimiques from "assets/puzzles/iserba/pacman/epi/gants_chimiques.svg";
import gantsElectricien from "assets/puzzles/iserba/pacman/epi/gants_electricien.svg";
import gantsEtanches from "assets/puzzles/iserba/pacman/epi/gants_etanches.svg";
import harnais from "assets/puzzles/iserba/pacman/epi/harnais.svg";
import lunettes from "assets/puzzles/iserba/pacman/epi/lunettes_de_sécurité.svg";
import manchette from "assets/puzzles/iserba/pacman/epi/manchette.svg";
import masqueSecu from "assets/puzzles/iserba/pacman/epi/masque_de_sécurité.svg";
import masqueProduit from "assets/puzzles/iserba/pacman/epi/masque_avec_cartouche_produit_chimique.svg";
import signalC11 from "assets/puzzles/iserba/pacman/epi/signal_c11.svg";
import tapis from "assets/puzzles/iserba/pacman/epi/tapis_de_sol_genoux.svg";
import verificateurTension from "assets/puzzles/iserba/pacman/epi/verificateur_absence_de_tension.svg";
import visiereProtectionElectrique from "assets/puzzles/iserba/pacman/epi/visiere_protection_electrique.svg";
import detartrantBidon from "assets/puzzles/iserba/pacman/epi/detartrant_bidon.svg";

//fantomes
import fantomeChaussure from "assets/puzzles/iserba/pacman/fantomes/fantome_chaussures_danger.svg";
import fantomeChute from "assets/puzzles/iserba/pacman/fantomes/fantome_chute.svg";
import fantomeDanger from "assets/puzzles/iserba/pacman/fantomes/fantome_danger.svg";
import fantomeElectrocution from "assets/puzzles/iserba/pacman/fantomes/fantome_electrocution.svg";
import fantomePinceDoigt from "assets/puzzles/iserba/pacman/fantomes/fantome_pince_doigt.svg";
import fantomeProduitsChimiques from "assets/puzzles/iserba/pacman/fantomes/fantome_produits_chimiques.svg";

//situations
import situation_1 from "assets/puzzles/iserba/pacman/situations/situation_1.svg";
import situation_2 from "assets/puzzles/iserba/pacman/situations/situation_2.svg";
import situation_3 from "assets/puzzles/iserba/pacman/situations/situation_3.svg";
import situation_4 from "assets/puzzles/iserba/pacman/situations/situation_4.svg";
import situation_5 from "assets/puzzles/iserba/pacman/situations/situation_5.svg";
import situation_6 from "assets/puzzles/iserba/pacman/situations/situation_6.svg";

// FALLING OBJECTS
import situation_baignoire from "assets/puzzles/iserba/fallingObjects/baignoire/situation_reparation_baignoire.svg";
import baignoire_bonne_position from "assets/puzzles/iserba/fallingObjects/baignoire/baignoire_bonne_position.svg";
import baignoire_mauvaise_position_1 from "assets/puzzles/iserba/fallingObjects/baignoire/baignoire_mauvaise_position_1.svg";
import baignoire_mauvaise_position_2 from "assets/puzzles/iserba/fallingObjects/baignoire/baignoire_mauvaise_position_2.svg";
import baignoire_mauvaise_position_3 from "assets/puzzles/iserba/fallingObjects/baignoire/baignoire_mauvaise_position_3.svg";

import situation_carton from "assets/puzzles/iserba/fallingObjects/carton/situation_carton.svg";
import carton_bonne_position from "assets/puzzles/iserba/fallingObjects/carton/carton_bonne_position.svg";
import carton_mauvaise_position_1 from "assets/puzzles/iserba/fallingObjects/carton/carton_mauvaise_position_1.svg";
import carton_mauvaise_position_2 from "assets/puzzles/iserba/fallingObjects/carton/carton_mauvaise_position_2.svg";
import carton_mauvaise_position_3 from "assets/puzzles/iserba/fallingObjects/carton/carton_mauvaise_position_3.svg";

import situation_chaudiere from "assets/puzzles/iserba/fallingObjects/chaudiere/situation_chaudiere.svg";
import situation_escalier from "assets/puzzles/iserba/fallingObjects/chaudiere/situation_escalier.svg";
import diable from "assets/puzzles/iserba/fallingObjects/chaudiere/diable_rouge.svg";
import ventouses from "assets/puzzles/iserba/fallingObjects/chaudiere/ventouses.svg";

import situation_toilettes from "assets/puzzles/iserba/fallingObjects/toilettes/situation_toilettes.svg";
import genouilleres from "assets/puzzles/iserba/fallingObjects/toilettes/genouilleres.svg";
import toilettes_bonne_position from "assets/puzzles/iserba/fallingObjects/toilettes/toilettes_bonne_position.svg";
import toilettes_mauvaise_position_1 from "assets/puzzles/iserba/fallingObjects/toilettes/toilettes_mauvaise_position_1.svg";
import toilettes_mauvaise_position_2 from "assets/puzzles/iserba/fallingObjects/toilettes/toilettes_mauvaise_position_2.svg";
import toilettes_mauvaise_position_3 from "assets/puzzles/iserba/fallingObjects/toilettes/toilettes_mauvaise_position_3.svg";

import situation_vmc from "assets/puzzles/iserba/fallingObjects/vmc/situation_vmc.svg";
import chaise_bar from "assets/puzzles/iserba/fallingObjects/vmc/chaise_bar.svg";
import chaise_roues from "assets/puzzles/iserba/fallingObjects/vmc/chaise_roues.svg";
import escabeau from "assets/puzzles/iserba/fallingObjects/vmc/escabeau.svg";
import table from "assets/puzzles/iserba/fallingObjects/vmc/table.svg";

import situation_sac from "assets/puzzles/iserba/fallingObjects/sac/situation_sac.svg";
import situation_sac_sans_perso from "assets/puzzles/iserba/fallingObjects/sac/situation_sac_sans_perso.svg";
import sac_bonne_reponse from "assets/puzzles/iserba/fallingObjects/sac/sac_bonne_reponse.svg";
import sac_mauvaise_reponse_1 from "assets/puzzles/iserba/fallingObjects/sac/sac_mauvaise_reponse_1.svg";
import sac_mauvaise_reponse_2 from "assets/puzzles/iserba/fallingObjects/sac/sac_mauvaise_reponse_2.svg";
import sac_mauvaise_reponse_3 from "assets/puzzles/iserba/fallingObjects/sac/sac_mauvaise_reponse_3.svg";

// THE SAFE PLACE
import situation_safe_place from "assets/puzzles/iserba/safePlace/situation_safe_place.svg";
import bouche_egout_decouverte from "assets/puzzles/iserba/safePlace/bouche_egout_decouverte.svg";
import bouche_egout_fermee from "assets/puzzles/iserba/safePlace/bouche_egout_fermee.svg";
import carton from "assets/puzzles/iserba/safePlace/carton.svg";
import echelle from "assets/puzzles/iserba/safePlace/echelle.svg";
import flaque_d_eau from "assets/puzzles/iserba/safePlace/flaque_d_eau.svg";
import nid_de_poule from "assets/puzzles/iserba/safePlace/nid_de_poule.svg";
import rembarde_cassee from "assets/puzzles/iserba/safePlace/rembarde_cassee.svg";
import rembarde_reparee from "assets/puzzles/iserba/safePlace/rembarde_reparee.svg";

export const iconMap = {
	// PACMAN GAME
	// 🟢 Equipment (EPI)
	barreArrimage: barreArrimage,
	bloqueDisjoncteur: bloqueDisjoncteur,
	cadenas: cadenas,
	casque: casque,
	casquette: casquette,
	chaussures: chaussures,
	gantsCoupures: gantsCoupures,
	gantsChimiques: gantsChimiques,
	gantsElectricien: gantsElectricien,
	gantsEtanches: gantsEtanches,
	harnais: harnais,
	lunettes: lunettes,
	manchette: manchette,
	masqueSecu: masqueSecu,
	masqueProduit: masqueProduit,
	signalC11: signalC11,
	tapis: tapis,
	verificateurTension: verificateurTension,
	detartrantBidon: detartrantBidon,
	visiereProtectionElectrique: visiereProtectionElectrique,

	// 👻 Ghosts
	fantomeChaussure: fantomeChaussure,
	fantomeChute: fantomeChute,
	fantomeDanger: fantomeDanger,
	fantomeElectrocution: fantomeElectrocution,
	fantomePinceDoigt: fantomePinceDoigt,
	fantomeProduitsChimiques: fantomeProduitsChimiques,

	// 🏗️ Situations
	situation_1: situation_1,
	situation_2: situation_2,
	situation_3: situation_3,
	situation_4: situation_4,
	situation_5: situation_5,
	situation_6: situation_6,

	// FALLING OBJECTS GAME
	situation_baignoire: situation_baignoire,
	baignoire_bonne_position: baignoire_bonne_position,
	baignoire_mauvaise_position_1: baignoire_mauvaise_position_1,
	baignoire_mauvaise_position_2: baignoire_mauvaise_position_2,
	baignoire_mauvaise_position_3: baignoire_mauvaise_position_3,

	situation_carton: situation_carton,
	carton_bonne_position: carton_bonne_position,
	carton_mauvaise_position_1: carton_mauvaise_position_1,
	carton_mauvaise_position_2: carton_mauvaise_position_2,
	carton_mauvaise_position_3: carton_mauvaise_position_3,

	situation_escalier: situation_escalier,
	situation_chaudiere: situation_chaudiere,
	diable: diable,
	ventouses: ventouses,

	situation_toilettes: situation_toilettes,
	genouilleres: genouilleres,
	toilettes_bonne_position: toilettes_bonne_position,
	toilettes_mauvaise_position_1: toilettes_mauvaise_position_1,
	toilettes_mauvaise_position_2: toilettes_mauvaise_position_2,
	toilettes_mauvaise_position_3: toilettes_mauvaise_position_3,

	situation_vmc: situation_vmc,
	chaise_bar: chaise_bar,
	chaise_roues: chaise_roues,
	escabeau: escabeau,
	table: table,

	situation_sac: situation_sac,
	situation_sac_sans_perso: situation_sac_sans_perso,
	sac_bonne_reponse: sac_bonne_reponse,
	sac_mauvaise_reponse_1: sac_mauvaise_reponse_1,
	sac_mauvaise_reponse_2: sac_mauvaise_reponse_2,
	sac_mauvaise_reponse_3: sac_mauvaise_reponse_3,

	// THE SAFE PLACE
	situation_safe_place: situation_safe_place,
	bouche_egout_decouverte: bouche_egout_decouverte,
	bouche_egout_fermee: bouche_egout_fermee,
	carton: carton,
	echelle: echelle,
	flaque_d_eau: flaque_d_eau,
	nid_de_poule: nid_de_poule,
	rembarde_cassee: rembarde_cassee,
	rembarde_reparee: rembarde_reparee,
};
